import React, { useState, useEffect, Fragment} from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Link from '@mui/material/Link';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Switch from '@mui/material/Switch';
import Checkbox from '@mui/material/Checkbox';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import Radio from '@mui/material/Radio';
import CircularProgress from '@mui/material/CircularProgress';
import RadioGroup from '@mui/material/RadioGroup';
import HorizontalSplitOutlinedIcon from '@mui/icons-material/HorizontalSplitOutlined';
import { Trans, withTranslation, useTranslation } from 'react-i18next';
import SolutionsArticleLink from './SolutionsArticleLink';


function fileSize(size) {
  var i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
  return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
}

const styles = {
  root: {
    '& .MuiButtonBase-root.MuiIconButton-root.MuiCheckbox-root': {
      padding: '4px 12px !important'
    },
    '&>.MuiDialogContentText-root': {
      marginBottom: '0px !important'
    }
  },
  dialog: {
    minWidth: '450px !important'
  },
  checkbox: {
    padding: '4px 12px !important'
  },
  loadingSign: {
    position: 'relative',
    margin: '4px',
  },
  loadingSpinnerContainer: {
    margin: 'auto',
    top: 1,
    position: 'absolute',
  },
  closeButton: (theme) => ({
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
    zIndex: 1
  }),
  selectFileBtn: {
    width: 'fit-content'
  }
};

function ExportImportDialogs(props) {
  const { t } = useTranslation();
  const [showDownloadDialog, setShowDownloadDialog] = useState(false);
  const [showImportCompleteDialog, setShowImportCompleteDialog] = useState(false);
  const [showImportSettingsDialog, setShowImportSettingsDialog] = useState(false);
  const [file, setFile] = useState(null);
  
  const [exportOptions, setExportOptions] = useState({
    product_tags: false,
    product_types: false,
    product_vendors: false,
    custom_contents: false,
    with_BOM: true,
    export_filter: '',
  });
  
  const [importOptions, setImportOptions] = useState({
    product_tags: false,
    product_types: false,
    product_vendors: false,
    custom_contents: props.scope === 'products' ? false : true, // TODO: Change back to true as soon CC is live
  });

  let inputRef = null;


  // One effect per trigger, each watching only its own prop. Sharing one effect meant every
  // unrelated dependency - a picked file, a toggled export option, an arriving download url -
  // re-ran all three bodies, so a prop still standing at true reopened its dialog on top of
  // whatever the user had just opened.
  useEffect(() => {
    if(props.forceOpenExportDialog === true) {
      onShowDownloadDialog();
    }
  }, [props.forceOpenExportDialog]);

  useEffect(() => {
    if(props.forceOpenImportDialog === true) {
      setShowImportSettingsDialog(true);
    }
  }, [props.forceOpenImportDialog]);

  useEffect(() => {
    if(props.showImportCompleteDialog === true) {
      onShowImportCompleteDialog();
    }
  }, [props.showImportCompleteDialog]);

  const onCancel = () => {
    if(props.clearFunc) {
      setTimeout(props.clearFunc, 1000);
    }
    setShowDownloadDialog(false);
  }
  const onDownload = () => {
    setShowDownloadDialog(false);
    if(props.clearFunc) {
      setTimeout(props.clearFunc, 1000);
    }
  }
  
  const onShowDownloadDialog = () => {
    setShowDownloadDialog(true);
  }
  const onCloseDownloadDialog = () => {
    setShowDownloadDialog(false);
  }

  const onShowImportCompleteDialog = () => {
    onCloseDownloadDialog();
    setShowImportCompleteDialog(true);
  }
  const onCloseImportCompleteDialog = () => {
    setShowImportSettingsDialog(false);
    setShowImportCompleteDialog(false);

    //window.location.reload();
  }

  const onChangeExportOption = (evt) => {
    let newExportOptions = {...exportOptions};
    if(evt.target.name === 'export_filter') {
      newExportOptions[evt.target.name] = evt.target.value;
    } else {
      newExportOptions[evt.target.name] = !newExportOptions[evt.target.name];
    }
    setExportOptions(newExportOptions);
  }
  const onGenerateDownload = () => {
    props.exportFunc(_cleanOptionsObjectForUrl(exportOptions));
  }

  const onChangeImportOption = (evt) => {
    let newImportOptions = {...importOptions};
    newImportOptions[evt.target.name] = !newImportOptions[evt.target.name];
    setImportOptions(newImportOptions);
  }
  const onSelectImportFile = (e) => {
    inputRef.click();
  }
  const onImportFile = (e) => {
    setShowImportSettingsDialog(false);
    const fileType = file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase();
    if(fileType != 'mo' && fileType != 'csv') {
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    props.importFunc(formData, fileType, _cleanOptionsObjectForUrl(importOptions));
  }


  const _cleanOptionsObjectForUrl = (options) => {
    const newOptions = {};
    Object.entries(options).map(opt => {
      if(props.additionalFields.indexOf(opt[0]) > -1) {
        if(opt[1] === true) {
          newOptions[opt[0]] = true;
        }
      }
      if(opt[0] === 'export_filter') {
        newOptions['export_filter'] = options.export_filter;
      }
    });
    return newOptions;
  }

  const handleClose = () => {
    setShowDownloadDialog(false);
    setShowImportSettingsDialog(false);
    setShowImportCompleteDialog(false);
  }

  return (
    <Box sx={styles.root}>
      <Dialog
        open={showDownloadDialog}
        onClose={onCloseDownloadDialog}
        aria-labelledby="export-dialog-title"
        aria-describedby="export-dialog-description"
        slotProps={{paper: {sx: styles.dialog}}}
      >
        <IconButton
          aria-label="close"
          sx={styles.closeButton}
          onClick={handleClose}
          size="large">
          <CloseIcon />
        </IconButton>
        {(props.export_po_download_url || props.export_csv_download_url) ? 
          <React.Fragment>
            <DialogTitle id="export-dialog-title">{t('exportFeature.step2.title')}</DialogTitle>
            <DialogContent>
              <DialogContentText id="export-dialog-description">
                <Trans i18nKey={'exportFeature.step2.info1'}></Trans>
                <br />
                <br />
                <Trans i18nKey={'exportFeature.step2.info2'}>
                  <Link
                    href="https://poedit.net/"
                    target="_blank"
                    color="primary"
                    rel="noreferrer"
                    underline="hover"></Link>
                </Trans>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={onCancel} color="primary">
                {t('system.cancel')}
              </Button>
              {props.export_advanced_csv_download_url &&
                <Button
                  href={props.export_advanced_csv_download_url}
                  onClick={onDownload}
                  download
                  variant="outlined"
                  color="primary"
                >
                  {t('exportFeature.downloadAdvancedCSV')}
                </Button>
              }
              <Button href={props.export_csv_download_url} onClick={onDownload} download variant="outlined" color="primary">{t('exportFeature.downloadCSV')}</Button>
              <Button href={props.export_po_download_url} onClick={onDownload} download variant="outlined" color="primary">{t('exportFeature.downloadPO')}</Button>
            </DialogActions>          
          </React.Fragment>
        : 
          <React.Fragment>
            <DialogTitle id="export-dialog-title">
              {t('exportFeature.step1.title')}
              <SolutionsArticleLink
                article="exportTranslations"
                subject={t('exportFeature.step1.title')}
                placement="dialogTitle"
              />
            </DialogTitle>
            <DialogContent id="export-dialog-description">
              <FormControl component="fieldset" fullWidth>
                <FormGroup>
                  {props.additionalFields.length > 1 && // TODO: Change back to 0 as soon CC is live
                    <React.Fragment>
                      <DialogContentText gutterBottom>{t('exportFeature.step1.info2')}</DialogContentText>
                      <FormControlLabel
                        control={<Checkbox checked={true} disabled sx={styles.checkbox} />}
                        label={t(`navigation.primary.${props.scope}`)}
                      />
                      {props.additionalFields.indexOf('product_tags') > -1 && 
                        <FormControlLabel
                          control={<Checkbox checked={exportOptions.product_tags} onChange={onChangeExportOption} name="product_tags" sx={styles.checkbox} />}
                          label={t('exportFeature.step1.tagsLabel')}
                        />
                      }
                      {props.additionalFields.indexOf('product_types') > -1 && 
                        <FormControlLabel
                          control={<Checkbox checked={exportOptions.product_types} onChange={onChangeExportOption} name="product_types" sx={styles.checkbox} />}
                          label={t('exportFeature.step1.typesLabel')}
                        />
                      }
                      {props.additionalFields.indexOf('product_vendors') > -1 && 
                        <FormControlLabel
                          control={<Checkbox checked={exportOptions.product_vendors} onChange={onChangeExportOption} name="product_vendors" sx={styles.checkbox} />}
                          label={t('exportFeature.step1.vendorsLabel')}
                        />
                      }
                      {props.additionalFields.indexOf('custom_contents') > -1 && 
                        <FormControlLabel
                          control={<Checkbox checked={exportOptions.custom_contents} onChange={onChangeExportOption} name="custom_contents" sx={styles.checkbox} />}
                          label={t('exportFeature.step1.customContentLabel')}
                        />
                      }
                      <Divider style={{ margin: '1rem 0'}}/> 
                    </React.Fragment>
                  }
                  <DialogContentText gutterBottom>{t('exportFeature.step1.info1')}</DialogContentText>
                  <FormControl>
                    {/*<FormLabel id="exportfilter-radio-buttons-group-label">{t('exportFeature.step1.exportFilterLabel')}</FormLabel>*/}
                    <RadioGroup
                      aria-labelledby="exportfilter-radio-buttons-group-label"
                      name="export_filter"
                      value={exportOptions['export_filter']}
                      onChange={onChangeExportOption}
                    >
                      <FormControlLabel value="" control={<Radio sx={styles.checkbox}  />} label={t('exportFeature.step1.exportFilterOption1')} />
                      <FormControlLabel value="untranslated" control={<Radio sx={styles.checkbox} />} label={t('exportFeature.step1.exportFilterOption2')} />
                      <FormControlLabel value="translated" control={<Radio sx={styles.checkbox} />} label={t('exportFeature.step1.exportFilterOption3')} />
                    </RadioGroup>
                  </FormControl>
                  {props.additionalFields.indexOf('with_BOM') > -1 && 
                  <FormControlLabel
                          control={<Checkbox checked={exportOptions.with_BOM} onChange={onChangeExportOption} name="with_BOM" sx={styles.checkbox} />}
                          label={t('exportFeature.step1.BOMLabel')}
                        />
                  }
                  {/** 
                  <FormControlLabel
                    control={<Checkbox checked={exportOptions.export_filter === 'translated' ? true : false} onChange={onChangeExportOption} name="export_filter" sx={styles.checkbox} />}
                    label={t('exportFeature.step1.exportFilterLabel')}
                  />
                  <FormHelperText>{t('exportFeature.step1.exportFilterSublabel')}</FormHelperText>
                  */}
                </FormGroup>
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button onClick={onCancel} color="primary">{t('system.cancel')}</Button>
              <Button onClick={onGenerateDownload} disabled={props.pending} variant="contained" color="primary">
                {t('exportFeature.step1.generateExport')}<SaveAltIcon style={{marginLeft: 8}} />
                <span style={styles.loadingSpinnerContainer}>
                  {props.pending &&
                    <CircularProgress sx={styles.loadingSign} size={25} />
                  }
                </span>
              </Button>
            </DialogActions>          
          </React.Fragment>
        }
      </Dialog>
      <Dialog
        open={showImportSettingsDialog}
        onClose={onCloseImportCompleteDialog}
        aria-labelledby="import-dialog-title"
        aria-describedby="import-dialog-description"
        slotProps={{paper: {sx: styles.dialog}}}
      >
        <DialogTitle id="import-dialog-title">
          {t('importFeature.settings.title')}
          <SolutionsArticleLink
            article="importTranslations"
            subject={t('importFeature.settings.title')}
            placement="dialogTitle"
          />
        </DialogTitle>
        <IconButton
          aria-label="close"
          sx={styles.closeButton}
          onClick={handleClose}
          size="large">
          <CloseIcon />
        </IconButton>
        <DialogContent id="import-dialog-description">
          <FormControl component="fieldset">
            <FormGroup>
              <DialogContentText>{t('importFeature.settings.selectFileInfo')}</DialogContentText>
              <input style={{display: 'none'}} 
                accept={'.mo,.csv'} 
                ref={(ref) => inputRef = ref} 
                type="file" 
                onChange={(e) => { setFile(e.target.files[0]); }}
              />
              <Button sx={styles.selectFileBtn} variant="contained" color="primary" size="large" onClick={onSelectImportFile}>{t('importFeature.settings.selectFileBtn')}</Button>
              {file &&
                <Typography variant="caption">
                  Name: {file.name}<br />
                  Filesize: {fileSize(file.size)}<br />
                  Type: {file.type}
                </Typography>
              }
              <FormHelperText>{t('importFeature.settings.selectFileSublabel')}</FormHelperText>
              {props.additionalFields.length > 1 && // TODO: Change back to 0 as soon CC is live
                <React.Fragment>
                  <Divider style={{ margin: '1rem 0'}}/> 
                  <DialogContentText>{t('importFeature.settings.optionsInfo')}</DialogContentText>
                  <FormControlLabel
                    control={<Checkbox checked={true} disabled sx={styles.checkbox} />}
                    label={t(`navigation.primary.${props.scope}`)}
                  />
                  {props.additionalFields.indexOf('product_tags') > -1 && 
                    <FormControlLabel
                      control={<Checkbox checked={importOptions.product_tags} onChange={onChangeImportOption} name="product_tags" sx={styles.checkbox} />}
                      label={t('exportFeature.step1.tagsLabel')}
                    />
                  }
                  {props.additionalFields.indexOf('product_types') > -1 && 
                    <FormControlLabel
                      control={<Checkbox checked={importOptions.product_types} onChange={onChangeImportOption} name="product_types" sx={styles.checkbox} />}
                      label={t('exportFeature.step1.typesLabel')}
                    />
                  }
                  {props.additionalFields.indexOf('product_vendors') > -1 && 
                    <FormControlLabel
                      control={<Checkbox checked={importOptions.product_vendors} onChange={onChangeImportOption} name="product_vendors" sx={styles.checkbox} />}
                      label={t('exportFeature.step1.vendorsLabel')}
                    />
                  }
                  {props.additionalFields.indexOf('custom_contents') > -1 && 
                    <FormControlLabel
                      control={<Checkbox checked={importOptions.custom_contents} onChange={onChangeImportOption} name="custom_contents" sx={styles.checkbox} />}
                      label={t('exportFeature.step1.customContentLabel')}
                    />
                  }                
                </React.Fragment>
              }
            </FormGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">{t('system.cancel')}</Button>
          <Button onClick={onImportFile} color="primary" variant="contained" disabled={!file}>
            {t('importFeature.settings.importBtn')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={showImportCompleteDialog}
        onClose={onCloseImportCompleteDialog}
        aria-labelledby="import-complete-dialog-title"
        aria-describedby="import-complete-dialog-description"
        slotProps={{paper: {sx: styles.dialog}}}
      >
        <DialogTitle id="import-complete-dialog-title">{t('importFeature.complete.title')}</DialogTitle>
        <IconButton
          aria-label="close"
          sx={styles.closeButton}
          onClick={handleClose}
          size="large">
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <DialogContentText id="import-complete-dialog-description">
            {props.imported_entries === 0 ?
              t('importFeature.complete.description', { imported_entries: props.imported_entries })
            :
              t('importFeature.complete.descriptionSuccess', { imported_entries: props.imported_entries })
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {props.imported_entries > 0 ?
            <React.Fragment>
              {/* custom_contents defaults to true, it only counts where the section offers it */}
              {(props.additionalFields.indexOf('custom_contents') > -1 && importOptions.custom_contents === true) || props.scope === 'custom' || !props.syncFunc ?
                <Button onClick={() => {window.location.reload()}} color="primary" variant="contained">
                  Resync
                </Button>
              :
                <Button onClick={() => {props.syncFunc(); onCloseImportCompleteDialog();}} color="primary" variant="contained">
                  Resync
                </Button>
              }
            </React.Fragment>
          :
            <Button onClick={onCloseImportCompleteDialog} color="primary" variant="contained">
              Ok
            </Button>
          }
        </DialogActions>
      </Dialog>
    </Box>
  );
}
ExportImportDialogs.defaultProps = {
  additionalFields: [],
  label: "Button Text"
};
export default ExportImportDialogs;